<template>
  <a-modal v-bind:open="computedShowModal"
  class="menu-modal-top"
  width="960px"
  :closable="true"
  :footer="null"
  :mask-closable="false"
  :mask-style="{backdropFilter: 'blur(2px)'}"
  :keyboard="false"
  :title="$t('menuModal_visibility_manage_title')"
  :centered="true"
  :wrap-class-name="overlayClassName"
  @cancel="uiHandler.closeModal"
  >
    <div class="modal-content-body">
      <!-- SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-b: 헤더 요약 — 편집 결과의 즉시 검산용(§2.2-2) -->
      <div v-if="categories && categories.length > 0" class="menu-modal-summary">
        {{ $t('menuModal_summary_count', { c: categorySummaryCounts.c, m: categorySummaryCounts.m }) }}
      </div>
      <!-- P2-①: 빈 계정 안내 — 노출 메뉴 0개일 때 시작 방법 제시 (SPEC-CHINA-MFR-STAFF-P2-POLISH-001) -->
      <a-alert
        v-if="!categories || categories.length === 0"
        type="info"
        show-icon
        style="margin-bottom: 12px;"
        :message="$t('menuModal_empty_state_title')"
        :description="$t('menuModal_empty_state_desc')"
      />
      <!-- SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-c(§2.3-①lite): 회사 미보유 모듈 경고 — 절대 비차단,
           저장 가능. moduleContext 가 없으면(다른 소비처 또는 조회 실패) 조용히 렌더 전무(fail-quiet) -->
      <a-alert
        v-if="showModuleWarnAlert"
        type="warning"
        show-icon
        style="margin-bottom: 12px;"
        :message="$t('iam_menu_ctx_warn_title', { n: missingModuleMenuCount })"
      />
      <a-alert
        v-if="showModuleMissingLedgerAlert"
        type="info"
        show-icon
        style="margin-bottom: 12px;"
        :message="$t('iam_menu_ctx_missing_ledger')"
      />
      <draggable
        class="card-body" 
        ghost-class="drag-ghost"
        :list="categories"
        :options="{
          handle: '.drag-btn'
        }"
        item-key="id"
      >
        <div v-for="(categoryItem, categoryIndex) in categories" class="category-container" :key="categoryItem._id">
          <div class="category-header">
            <div class="header-left">
              <section class="drag-btn">
                <i class="fa-solid fa-grip-vertical"/>
              </section>
              <h4>{{ categoryItem.name }}</h4>
            </div>
            <!-- SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-b(§2.2-3): 파괴 동작을 헤더로 격리 —
                 메뉴 X(즉시)와 위치·색·확인 유무를 전부 달리해 오조작 구조를 없앤다 -->
            <a-tooltip :title="$t('menuModal_category_remove_confirm_title')">
              <button
                type="button"
                class="category-remove-btn"
                @click="uiHandler.removeCategory(categoryIndex)"
              >
                <i class="fa-solid fa-x"/>
              </button>
            </a-tooltip>
          </div>
          <draggable 
            class="menu-container" 
            ghost-class="drag-ghost"
            :list="categoryItem.menu"
            item-key="id"
            :options="{
              handle: '.drag-btn'
            }"
          >
            <div 
              class="col-sm-12 inputDiv mb-0 menu-wrapper"
              v-for="(menuItem, menuIndex) in categoryItem.menu"  
              :list="categoryItem.menu"
              :key="menuItem.menuId"
            >
              <div class="menu-wrap">
                <div class="menu-header">
                  <div class="menu-header-left">
                    <section class="drag-btn">
                      <i class="fa-solid fa-grip-vertical"/>
                    </section>
                    <h4>{{ menuItem.menuName }}</h4>
                    <!-- SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-c(§2.3-①lite): 회사 미보유 모듈 배지 —
                         정보 제공뿐, 저장을 막지 않는다 -->
                    <a-tooltip
                      v-if="missingModuleMenuMap.has(menuItem.menuId)"
                      :title="$t('iam_menu_ctx_badge_tooltip', { label: missingModuleMenuMap.get(menuItem.menuId).label })"
                    >
                      <a-tag color="orange" class="menu-module-badge">
                        {{ missingModuleMenuMap.get(menuItem.menuId).label }}
                      </a-tag>
                    </a-tooltip>
                    <!-- 보유 모듈 배지(양성) — 미보유 경고와 대칭. moduleContext 없으면 렌더 전무 -->
                    <a-tooltip
                      v-else-if="heldModuleMenuMap.has(menuItem.menuId)"
                      :title="$t('iam_menu_ctx_held_tooltip', { label: heldModuleMenuMap.get(menuItem.menuId).label })"
                    >
                      <a-tag color="blue" class="menu-module-badge">
                        {{ heldModuleMenuMap.get(menuItem.menuId).label }}
                      </a-tag>
                    </a-tooltip>
                    <!-- 메뉴 신원 병기 — 이름만으로 구분 안 되는 동명 메뉴를 경로로 식별 -->
                    <span v-if="menuItem.link" class="menu-link-sub">{{ menuItem.link }}</span>
                  </div>
                  <!-- SPEC-CHINA-AUTHZ-CONSOLIDATE-001 M2(D3): 권한 체크박스(read/write/update/delete/excel) 전면 제거.
                       노출은 메뉴 항목의 존재로 결정되므로 per-menu 권한 UI 불필요. 기존 플래그 값(read/write/readOptions 등)은
                       데이터 모델에 그대로 남아 저장 시 라운드트립 보존된다(D4). -->
                </div>
                <button 
                  class="menu-remove-btn"
                  @click="uiHandler.removeMenu(categoryIndex, menuIndex)"  
                >
                  <i class="fa-solid fa-xmark" />
                </button>
              </div>
            </div>
            <button 
              type="button"
              class="add-product-btn"
              @click="uiHandler.openMenuModal(categoryIndex)"
              v-if="categoryItem.shouldShowAddMenuBtn"
            >
              <i class="fa-solid fa-plus"/> {{$t('manu_acc_modal_add_menu')}}
            </button>
          </draggable>
        </div>
      </draggable>
    </div>
    <!-- 메뉴 복사 패널 -->
    <div v-if="copyPanel.open" class="copy-panel" style="border:1px solid #d9d9d9; border-radius:6px; padding:12px 16px; margin:8px 0; background:#fafafa;">
      <div style="font-weight:600; margin-bottom:8px;">{{ $t('menuModal_copy_panel_title') }}</div>
      <div style="display:flex; flex-wrap:wrap; gap:8px; align-items:center;">
        <a-select
          v-model:value="copyPanel.selectedUsername"
          :placeholder="$t('menuModal_copy_select_placeholder')"
          style="min-width:200px; flex:1;"
          allow-clear
        >
          <a-select-option
            v-for="acc in filteredCopySourceAccounts"
            :key="acc.username"
            :value="acc.username"
          >
            {{ acc.name }} ({{ acc.username }})
          </a-select-option>
        </a-select>
        <a-input
          v-model:value="copyPanel.typedUsername"
          :placeholder="$t('menuModal_copy_input_placeholder')"
          style="min-width:160px; flex:1;"
          allow-clear
        />
        <a-button
          type="primary"
          @click="uiHandler.copyMenusFrom(copyPanel.selectedUsername || copyPanel.typedUsername)"
        >
          {{ $t('menuModal_copy_confirm_btn') }}
        </a-button>
        <a-button @click="copyPanel.open = false; copyPanel.selectedUsername = undefined; copyPanel.typedUsername = ''">
          {{ $t('common_cancel') }}
        </a-button>
      </div>
    </div>
    <!-- 변경 이력 패널 (SPEC-CHINA-PRIV-AUDIT-001) -->
    <div v-if="auditPanel.open" class="audit-panel" style="border:1px solid #d9d9d9; border-radius:6px; padding:12px 16px; margin:8px 0; background:#fafafa; max-height:280px; overflow-y:auto;">
      <div style="font-weight:600; margin-bottom:8px;">{{ $t('menuModal_audit_panel_title') }}</div>
      <div v-if="auditPanel.loading" style="color:#999;">{{ $t('common_loading') }}</div>
      <div v-else-if="auditPanel.error" style="color:#999;">{{ $t('menuModal_audit_load_error') }}</div>
      <a-empty v-else-if="auditSummaries.length === 0" :description="$t('menuModal_audit_empty')" />
      <ul v-else style="list-style:none; padding:0; margin:0;">
        <li v-for="row in auditSummaries" :key="row.item.id" style="padding:8px 0; border-bottom:1px solid #eee;">
          <div style="display:flex; align-items:center; gap:8px; flex-wrap:wrap;">
            <a-tag :color="auditActionColor(row.item.action)">{{ auditActionLabel(row.item.action) }}</a-tag>
            <span style="font-size:12px; color:#666;">{{ row.item.actorUsername }}</span>
            <span style="font-size:12px; color:#999;">{{ formatAuditDate(row.item.changedAt) }}</span>
          </div>
          <div v-if="row.item.reason" style="font-size:12px; color:#666; margin-top:2px;">
            {{ $t('menuModal_audit_reason_label') }}: {{ row.item.reason }}
          </div>
          <div style="font-size:12px; margin-top:4px;">
            <span v-if="row.added.length" style="color:#389e0d; margin-right:8px;">{{ $t('menuModal_audit_added_label') }}: {{ row.added.join(', ') }}</span>
            <span v-if="row.removed.length" style="color:#cf1322; margin-right:8px;">{{ $t('menuModal_audit_removed_label') }}: {{ row.removed.join(', ') }}</span>
            <span v-if="!row.added.length && !row.removed.length" style="color:#999;">{{ $t('menuModal_audit_no_changes') }}</span>
          </div>
        </li>
      </ul>
    </div>
    <!-- SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-b(§2.2-5): 푸터 위계 분리 — 좌측 '+카테고리 추가'만
         기존 dashed 스타일(유일한 '추가' 계열)을 유지하고, '메뉴 복사'·'변경 이력'은 text 버튼으로
         강등한다. 최종 저장 버튼만 primary(유일한 강조색). -->
    <div class="menu-modal-footer menu-modal-toolbar">
      <button
        type="button"
        class="add-product-btn"
        @click="uiHandler.openCategoryModal"
        v-if="showAddCategoryBtn"
      >
        <i class="fa-solid fa-plus"/> {{$t('manu_acc_modal_add_category')}}
      </button>
      <span class="menu-modal-toolbar-spacer"></span>
      <a-button
        type="text"
        @click="copyPanel.open = !copyPanel.open"
      >
        <i class="fa-solid fa-copy" style="margin-right:4px;"/> {{ $t('menuModal_copy_btn') }}
      </a-button>
      <a-button
        type="text"
        @click="uiHandler.toggleAuditPanel"
      >
        <i class="fa-solid fa-clock-rotate-left" style="margin-right:4px;"/> {{ $t('menuModal_audit_toggle_btn') }}
      </a-button>
    </div>
    <div class="menu-modal-footer menu-modal-footer-main" style="align-items:center; gap:8px;">
      <a-input
        v-model:value="changeReason"
        :placeholder="$t('menuModal_reason_placeholder')"
        :maxlength="200"
        allow-clear
        style="flex:1; min-width:180px;"
      />
      <a-button
      @click="uiHandler.closeModal"
    >
      {{$t('common_cancel')}}
    </a-button>
      <a-button
        type="primary"
        @click="uiHandler.updatePrivilegeInfo"
      >
        {{$t('manu_acc_modal_save_privilege')}}
      </a-button>
    </div>
  </a-modal>
  <a-modal v-model:open="subModalOpen"
    width="400px"
    :closable="true"
    :footer="null"
    :mask-closable="false"
    :mask-style="{backdropFilter: 'blur(2px)'}"
    :keyboard="false"
    :title="computedTitle"
    :centered="true"
    :wrap-class-name="subOverlayClassName"
    @cancel="uiHandler.closeSubModal"
  >
    <div class="modal-content-body filtered-items">
      <div 
        class="menu-checkboxes"
        v-if="modalData.targetModalData === TargetModalDataEnum.CATEGORY"
      >
        <div 
          class="checkbox-wrap"
          v-for="(item, index) in modalData.filteredCategories"
          :key="item+index"
        >
          <input 
            type="checkbox"
            :id="item+index"
            v-model="modalData.selectedCategories"
            :value="item"
          />
          <label :for="item+index">{{ item }}</label>
        </div>
      </div>
      <template v-else>
        <!-- 검색 — 이름/경로 부분일치. 동명 메뉴를 경로로 구분한다 -->
        <a-input
          v-model:value="menuSearch"
          :placeholder="$t('menuModal_search_placeholder')"
          allow-clear
          style="margin-bottom: 8px;"
        />
        <div class="menu-checkboxes menu-checkboxes--menu-picker">
          <div
            class="checkbox-wrap"
            v-for="(item, index) in filteredMenusView"
            :key="item+index"
          >
            <input
              type="checkbox"
              :id="item.name+index"
              v-model="modalData.selectedMenu"
              :value="item"
            />
            <label :for="item.name+index">
              {{ item.name }}
              <span v-if="item.link" class="menu-link-sub">{{ item.link }}</span>
            </label>
          </div>
          <div v-if="filteredMenusView.length === 0" style="color: #999; text-align: center; padding: 8px;">
            {{ $t('menuModal_search_no_result') }}
          </div>
        </div>
      </template>
    </div>
    <div class="menu-modal-footer">
      <a-button
      @click="uiHandler.closeSubModal"
    >
      {{$t('common_cancel')}}
    </a-button>
      <a-button
        type="primary"
        @click="uiHandler.processAdd"
      >
        {{$t('common_add')}}
      </a-button>
    </div>
  </a-modal>
</template>
  
<script>
import { VueDraggableNext } from 'vue-draggable-next'
import enums from '@/utils/enums';
import { jwtUsername,
  oneBtnDialog,
  twoBtnDialog,
  convertYnToBool,
  boolToYn,
  deepCopy,
} from '@/utils/utils';
import { modalType, TargetModalDataEnum, } from '../enums/enums';
import dayjs from 'dayjs';
import { computeMissingModuleMenuMap, computeHeldModuleMenuMap } from './missingModuleMenuMap';
// @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-STORE-HYGIENE-001 — chinaInapi 직접 호출 제거, store action(fetchPrivilegesRaw/updatePrivilege) 사용

const { YnEnum } = enums();

export default {
  name: 'MenuManageModal',
  components: {
    draggable: VueDraggableNext,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    username: {
      type: String,
      required: true,
      default: 'dentium',
    },
    /**
     * 편집 대상 계정의 role — 메뉴 카탈로그 피커 필터에 그대로 쓰인다.
     * 미지정 시 store가 'MANUFACTURER'로 폴백하므로 기존 호출처는 동작이 바뀌지 않는다.
     */
    targetRole: {
      type: String,
      default: '',
    },
    // 메뉴 복사 소스 후보 계정 목록 (같은 회사 계정) — {username, name} 배열
    copySourceAccounts: {
      type: Array,
      default: () => [],
    },
    /**
     * SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-a: 오버레이 z-index 스코프 클래스(공유 컴포넌트
     * prop-gate). 빈 문자열(기본값)이면 wrap-class-name 미부여 = 현행 antd 기본 z-index 그대로라
     * 미전달 소비처(MfrStaffManage/AccountManageModal)는 동작이 바뀌지 않는다. IamConsole 소비처만
     * 'iam-menu-modal-overlay' 를 전달해 사용자 상세 드로어(z 1100) 위에 뜨도록 한다.
     */
    overlayClassName: {
      type: String,
      default: '',
    },
    /**
     * SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-c(§2.3-①lite): 회사 미보유 모듈 경고 주석 컨텍스트.
     * 정보 제공 전용 — 저장 payload·validate·copy·audit 로직과 무관하다(REQ-TE-000 WARN only 계승,
     * 절대 비차단 J5). null(기본값)이면 배지·경고 렌더 전무하고 다른 소비처는 영향 없음.
     * @property {'ASSIGNED'|'EMPTY'|'MISSING'} ledgerState
     * @property {string[]} heldModuleCodes - 회사 원장 보유 feature 모듈 code
     * @property {Object<string,{code:string,label:string}>} linkToModule - menu.link → 모듈 매핑(feature만)
     */
    moduleContext: {
      type: Object,
      default: null,
    },
  },
  computed: {
    computedShowModal() {
      return this.showModal;
    },
    // 서브모달(카테고리/메뉴 피커) 전용 z 티어 — 동일 z + DOM 순서 의존은 antd lazy teleport
    // 타이밍에 흔들릴 수 있어 메인 모달과 명시적으로 분리한다(설계 J9).
    subOverlayClassName() {
      return this.overlayClassName ? `${this.overlayClassName}-sub` : '';
    },
    // SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-b(§2.2-2): 헤더 요약 카운트 — 편집 결과 즉시 검산용
    categorySummaryCounts() {
      const c = (this.categories || []).length;
      const m = (this.categories || []).reduce((sum, cat) => sum + ((cat.menu || []).length), 0);
      return { c, m };
    },
    // SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-c(§2.3-①lite): menu.link → 미보유 모듈 매핑.
    // fail-quiet(J5·J7) — moduleContext=null·link 미매핑·MISSING 원장(전 메뉴 배지 대신 info alert
    // 1개만, §2.3-①lite 렌더 규칙)이면 조용히 빈 결과.
    missingModuleMenuMap() {
      return computeMissingModuleMenuMap(this.categories, this.moduleContext);
    },
    // 보유(양성) 모듈 매핑 — 미보유 배지와 대칭. 어느 보유 모듈의 메뉴인지 편집 중에도 보이게 한다
    heldModuleMenuMap() {
      return computeHeldModuleMenuMap(this.categories, this.moduleContext);
    },
    // 메뉴 추가 서브모달 검색 — 이름/경로 부분일치(동명 메뉴를 경로로 구분)
    filteredMenusView() {
      const q = (this.menuSearch || '').trim().toLowerCase();
      const items = this.modalData.filteredMenus || [];
      if (!q) return items;
      return items.filter((item) =>
        String(item.name || '').toLowerCase().includes(q)
        || String(item.link || '').toLowerCase().includes(q));
    },
    missingModuleMenuCount() {
      return this.missingModuleMenuMap.size;
    },
    showModuleWarnAlert() {
      return !!this.moduleContext && this.missingModuleMenuCount > 0;
    },
    showModuleMissingLedgerAlert() {
      return !!this.moduleContext && this.moduleContext.ledgerState === 'MISSING';
    },
    computedTitle() {
      return this.modalData.targetModalData === TargetModalDataEnum.CATEGORY
        ? this.$t('menuModal_sub_title_category')
        : this.$t('menuModal_sub_title_menu');
    },
    showAddCategoryBtn() {
      // 카탈로그 전체 카테고리 중 아직 추가되지 않은 카테고리가 있으면 버튼 노출
      // (신규/빈 계정에서 filteredCategories 타이밍과 무관하게 동작)
      const all = new Set((this.modalData.wholeMenuData || []).map(i => i.category));
      const added = new Set((this.categories || []).map(c => c.name));
      for (const c of all) {
        if (!added.has(c)) return true;
      }
      return false;
    },
    // 메뉴 복사 드롭다운에 표시할 계정 목록 (현재 편집 중인 username 제외)
    // SPEC-CHINA-PRIV-AUDIT-001: menuId → 메뉴명 매핑 (카탈로그는 이미 locale hydrated)
    menuNameMap() {
      const map = new Map();
      (this.modalData.wholeMenuData || []).forEach(m => {
        if (m && m._id != null) map.set(String(m._id), m.name);
      });
      return map;
    },
    // 변경 이력 각 항목을 읽기 쉬운 diff 요약으로 변환 (렌더당 1회)
    auditSummaries() {
      const nameMap = this.menuNameMap;
      return (this.auditPanel.items || []).map(item => {
        const diff = this.buildAuditDiff(item.beforeSnapshot, item.afterSnapshot, nameMap);
        return { item, ...diff };
      });
    },
    filteredCopySourceAccounts() {
      return (this.copySourceAccounts || []).filter(
        acc => acc.username !== this.username
      );
    },
  },
  emits: ['closeModal'],
  data() {
    return {
      categories: [],
      uiHandler: this.ui(),
      apiHandler: this.api(),
      YnEnum,
      subModalOpen: false,
      // 메뉴 추가 서브모달 검색어 — 열 때마다 초기화
      menuSearch: '',
      
      TargetModalDataEnum,
      modalData: {
        wholeMenuData: [], // 메뉴 전체 데이터
        targetModalData: TargetModalDataEnum.INIT, // 서브모달에 카테고리 띄울지, 메뉴를 띄울지
        filteredCategories: [], // 모달에서 띄워줄 기선택된 항목 제외한 카테고리 배열
        filteredMenus: [], // 모달에서 띄워줄 기선택된 항목 제외한 메뉴 배열
        selectedMenu: [], // 모달에서 선택한 메뉴(v-model)
        selectedCategoryArrayIndex: 0, // 메뉴 추가 했을 때 이벤트가 발생한 카테고리의 배열 인덱스
        selectedCategories: [], // 모달에서 선택한 카테고리(v-model)
      },
      // 메뉴 복사 패널 상태
      copyPanel: {
        open: false,
        selectedUsername: undefined, // a-select v-model
        typedUsername: '',           // 직접 입력 input v-model
      },
      // SPEC-CHINA-PRIV-AUDIT-001: 변경 사유 입력 + 변경 이력 패널 상태
      changeReason: '',
      auditPanel: {
        open: false,
        loading: false,
        error: false,
        loaded: false, // 재오픈 시 재조회 방지
        items: [],
      },
    };
  },

  async mounted() {
    await this.uiHandler.getMenuList();
  },
  watch: {
    async showModal(newValue, oldValue) {
      if(newValue) {
        // 모달을 열 때마다 메뉴 카탈로그를 재조회한다. mounted 1회 조회만으로는
        // 이후 menus 컬렉션 변경(공용화·신설·삭제)이 열린 페이지에 반영되지 않아
        // "+메뉴 추가하기" 버튼이 계속 숨는 스테일 문제가 있었다.
        // getPrivilegeInfo는 카탈로그(wholeMenuData) 대비 배정 수로
        // shouldShowAddMenuBtn을 계산하므로 카탈로그를 먼저 await한다.
        await this.uiHandler.getMenuList();
        this.uiHandler.getPrivilegeInfo();
        // SPEC-CHINA-PRIV-AUDIT-001: 다른 계정 편집 시 이전 이력/사유 잔존 방지
        this.changeReason = '';
        this.auditPanel.open = false;
        this.auditPanel.loaded = false;
        this.auditPanel.error = false;
        this.auditPanel.items = [];
      }
    }
  },
  methods: {
    // ===== SPEC-CHINA-PRIV-AUDIT-001 / AUTHZ-CONSOLIDATE-001 M2: 감사 이력 렌더 순수 헬퍼 =====
    // before/after 스냅샷(카테고리 배열)을 menuId 기준 diff 요약으로 변환.
    // create → before=null(전부 추가), delete → after=null(전부 제거).
    // 반환: { added:[name], removed:[name] } — 권한 플래그 changed는 M2에서 제거(REQ-ACL-047).
    buildAuditDiff(beforeSnapshot, afterSnapshot, nameMap) {
      const flatten = (snap) => {
        const map = new Map();
        (Array.isArray(snap) ? snap : []).forEach(cat => {
          (cat && Array.isArray(cat.menu) ? cat.menu : []).forEach(m => {
            if (m && m.menuId != null) map.set(String(m.menuId), m);
          });
        });
        return map;
      };
      const nameOf = (id) => (nameMap && nameMap.get(String(id))) || String(id);
      const beforeMap = flatten(beforeSnapshot);
      const afterMap = flatten(afterSnapshot);
      // SPEC-CHINA-AUTHZ-CONSOLIDATE-001 M2(REQ-ACL-047): 권한 플래그(read/write)는 더 이상 사용자 조작이
      // 아니므로 flag on/off(changed) 산출을 제거하고 메뉴 항목의 추가/제거만 표면화한다.
      const added = [];
      const removed = [];
      afterMap.forEach((m, id) => {
        if (!beforeMap.has(id)) added.push(nameOf(id));
      });
      beforeMap.forEach((m, id) => {
        if (!afterMap.has(id)) removed.push(nameOf(id));
      });
      return { added, removed };
    },
    auditActionColor(action) {
      return action === 'create' ? 'green' : action === 'delete' ? 'red' : 'blue';
    },
    auditActionLabel(action) {
      if (action === 'create') return this.$t('menuModal_audit_action_create');
      if (action === 'delete') return this.$t('menuModal_audit_action_delete');
      return this.$t('menuModal_audit_action_update');
    },
    formatAuditDate(iso) {
      if (!iso) return '';
      const d = dayjs(iso);
      return d.isValid() ? d.format('YYYY-MM-DD HH:mm') : String(iso);
    },
    ui() {
      return {
        /*
        
        카테고리 선택 모달창 on

        메뉴데이터 전체에서 카테고리명 뽑아서 중복 제거
        filteredCategories

        */
        openCategoryModal: ()=> {
          const categories = Array.from(new Set(this.modalData.wholeMenuData.map(item => item.category)));

          // P2-⑥(a): 피커 정렬 — locale-aware 사전순 (openCategoryModal 재계산 지점)
          this.modalData.filteredCategories = categories
            .filter(uniqueCategory => !this.categories.some(category => category.name === uniqueCategory))
            .sort((a, b) => String(a).localeCompare(String(b)));

          this.subModalOpen = true;
          this.modalData.targetModalData = TargetModalDataEnum.CATEGORY;
        },
        /*
        
        메뉴 선택 모달창 on

        선택한 카테고리 명 추출한 뒤 전체 메뉴 데이터에서 카테고리 명 일치하는 것만 추출
        다만 해당 카테고리에 기등록 되어 있는 메뉴는 제외
        filteredMenus에 담음
        그리고 배열의 몇 번째 카테고리인지 추출하여 저장(해당 카테고리에 메뉴를 추가해야 하기 때문)

        */
        openMenuModal: (index)=> {
          const targetCategory = this.categories[index];
          const categoryName = targetCategory.name;
          const array = deepCopy(this.modalData.wholeMenuData.filter(item => item.category === categoryName));
          const targetMenuNames = deepCopy(targetCategory.menu).map(menuItem => menuItem.menuName);
          const filteredArray = array.filter(item => 
            !targetMenuNames.includes(item.name)
          );
          // P2-⑥(a): 메뉴 피커 정렬 — locale-aware 사전순
          this.modalData.filteredMenus = filteredArray.sort((a, b) => String(a.name).localeCompare(String(b.name)));
          this.menuSearch = '';
          this.subModalOpen = true;
          this.modalData.selectedCategoryArrayIndex = index;
          this.modalData.targetModalData = TargetModalDataEnum.MENU;
        },
        /*
        
        카테고리/메뉴 추가(카테고리 모달이면 카테고리 추가, 메뉴 모달이면 메뉴 추가)

        */
        processAdd: async () => {
          if(this.modalData.targetModalData === TargetModalDataEnum.CATEGORY) {
            if(this.modalData.selectedCategories.length === 0) {
              await oneBtnDialog(this.$t('menuModal_category_empty_title'), this.$t('menuModal_category_empty_msg'), false);
              return;
            }
            this.uiHandler.addCategory();
            return;
          }
          if(this.modalData.targetModalData === TargetModalDataEnum.MENU) {
            this.uiHandler.addMenu();
            return;
          }
        },
        /*
        
        카테고리 추가 로직
        submit 할 때의 카테고리 데이터셋과 똑같은 구조의 object 생성
        단, 더 추가할 메뉴가 없는 경우 메뉴 추가 버튼이 있으면 안되기 때문에 
        shouldShowAddMenuBtn 불리언값도 추가(기본: 버튼 노출)

        선택한 카테고리가 selectedCategories에 없으면 categories에 넣고 filtererdCategories에서 제거

        */
        addCategory: () => {
          const obj = {
            name: this.modalData.selectedCategories,
            menu: [],
            shouldShowAddMenuBtn: true,
          }

          for(let i = this.modalData.filteredCategories.length - 1; i >=0; i --) {
            const item = this.modalData.filteredCategories[i];
            if(this.modalData.selectedCategories.indexOf(item) !== -1) {
              const obj = {
                name: item,
                menu: [],
                shouldShowAddMenuBtn: true,
              }
              this.categories.push(obj);

              this.modalData.filteredCategories.splice(i, 1);
            }
          }
        
          this.subModalOpen = false;
          this.modalData.selectedCategories = [];
        },
        /*

        메뉴 추가 로직
        
        우선 카테고리 이름이 null이거나 undefined인 경우 return

        computeMenuObject메소드를 통해 /menus/list 에 맞는 데이터포맷으로 변환(UI에 그려주기 위해)

        선택한 카테고리에 선택한 메뉴들 추가

        그리고 filteredMenus에서 해당 메뉴들 제거

        더이상 선택할 메뉴가 없다면 shouldShowAddMenuBtn 불리언 false로

        */
        addMenu: async () => {
          const targetCategory = this.categories[this.modalData.selectedCategoryArrayIndex];
          const categoryName = targetCategory.name;
          if(typeof categoryName === 'undefined' || categoryName === null) return;

          if(this.modalData.selectedMenu.length === 0) {
            await oneBtnDialog(this.$t('menuModal_menu_empty_title'), this.$t('menuModal_menu_empty_msg'), false);
            return;
          }
          const selectedMenu = deepCopy(this.modalData.selectedMenu).map(item => this.uiHandler.computeMenuObject(item));

          targetCategory.menu.push(...selectedMenu);
          for(let i = this.modalData.filteredMenus.length - 1; i >= 0; i --) {
            const item = this.modalData.filteredMenus[i];
            for(let j = 0; j < targetCategory.menu.length; j ++) {
              if(item.name === targetCategory.menu[j].menuName) {
                this.modalData.filteredMenus.splice(i, 1);
              } 
              targetCategory.menu[j].shouldShowAddMenuBtn = true;
            }
          }
          if(this.modalData.filteredMenus.length === 0) targetCategory.shouldShowAddMenuBtn = false;
          this.subModalOpen = false;
          this.modalData.selectedMenu = [];
        },
         /*

        카테고리 선택한거 삭제

        SPEC-CHINA-GEO-EDITOR-FIELD-UX-001 M-b(§2.2-3): 메뉴가 1개 이상 든 카테고리는
        twoBtnDialog 확인 후 삭제(REQ-TE-000 과 무관 — 저장 전까지는 취소로 복구 가능하다는
        UX 안내일 뿐, 이 확인은 서버 상태를 건드리지 않는다). 빈 카테고리는 확인 없이 즉시 삭제.

        */
        removeCategory: async (categoryIndex) => {
          const target = this.categories[categoryIndex];
          const menuCount = (target && target.menu) ? target.menu.length : 0;
          if (menuCount > 0) {
            const confirmed = await twoBtnDialog(
              this.$t('menuModal_category_remove_confirm_title'),
              this.$t('menuModal_category_remove_confirm_msg', { n: menuCount }),
              this.$t('menuModal_category_remove_confirm_title'),
              this.$t('common_cancel')
            );
            if (!confirmed) return;
          }
          this.categories.splice(categoryIndex, 1);
        },
        /*

        메뉴 제거

        선택한 카테고리와 원천데이터의 메뉴 갯수 비교하여 메뉴 추가 버튼 노출/숨김

        */
        removeMenu: (categoryIndex, menuIndex) => {
          this.categories[categoryIndex].menu.splice(menuIndex, 1);

          const data = this.modalData.wholeMenuData.filter(item => item.category === this.categories[categoryIndex].name);
          if(data.length <= this.categories[categoryIndex].menu.length - 1) {
            this.categories[categoryIndex].shouldShowAddMenuBtn = false;
          } else {
            this.categories[categoryIndex].shouldShowAddMenuBtn = true;
          }
        },
        /*

        권한관리 모달 close

        targetModalData 값 초기화 하고
        subModal 값도 초기화

        */
        // SPEC-CHINA-PRIV-AUDIT-001: 변경 이력 패널 토글 (첫 오픈 시 lazy load)
        toggleAuditPanel: async () => {
          this.auditPanel.open = !this.auditPanel.open;
          if (this.auditPanel.open && !this.auditPanel.loaded) {
            await this.uiHandler.loadAudits();
          }
        },
        // 감사 이력 조회 — 실패해도 모달 흐름 유지(muted 에러 표시)
        loadAudits: async () => {
          this.auditPanel.loading = true;
          this.auditPanel.error = false;
          try {
            const res = await this.apiHandler.getPrivilegeAudits(this.username, 20);
            this.auditPanel.items = Array.isArray(res && res.data) ? res.data : [];
            this.auditPanel.loaded = true;
          } catch (e) {
            console.log(e);
            this.auditPanel.error = true;
          } finally {
            this.auditPanel.loading = false;
          }
        },
        closeModal: () => {
          this.uiHandler.closeSubModal();
          this.targetModalData = TargetModalDataEnum.INIT;
          // 복사 패널 상태 초기화
          this.copyPanel.open = false;
          this.copyPanel.selectedUsername = undefined;
          this.copyPanel.typedUsername = '';
          // SPEC-CHINA-PRIV-AUDIT-001: 변경 사유/이력 패널 초기화
          this.changeReason = '';
          this.auditPanel.open = false;
          this.auditPanel.loaded = false;
          this.auditPanel.error = false;
          this.auditPanel.items = [];
          this.$emit('closeModal', modalType.menu, false);
        },
        /*

        subModal close

        */
        closeSubModal: () => {
          this.subModalOpen = false;
          if(this.modalData.targetModalData ===TargetModalDataEnum.CATEGORY) {
            this.modalData.selectedCategories = [];
            this.modalData.filteredCategories = [];
            return;
          }
          if(this.modalData.targetModalData ===TargetModalDataEnum.MENU) {
            this.modalData.selectedMenu = [];
            this.modalData.filteredMenus = [];
            return;
          }
        },
        /*

        메뉴 전체 가져오기

        */
        getMenuList: async () => {
          const result = await this.apiHandler.getMenuList();
          if(result.data) this.modalData.wholeMenuData = result.data.docs;
        },
        /*

        해당 유저의 권한 가져오기
        
        username이 없는 경우, response가 아예 없는 경우 자름(비정상케이스)
        categories가 없으면 그냥 빈배열로 함수 리턴(정상케이스이나 이후 처리 불필요)
        categories배열에 값이 있는 경우
        Yn을 boolean 값으로 변환

        각 카테고리별로 총 메뉴 갯수에서 이미 등록된 메뉴 갯수를 제하여 0보다 크면 메뉴 추가 버튼 노출

        */
        getPrivilegeInfo: async () => {
          if(!this.username) return;
          const result = await this.apiHandler.getPrivilegeInfo(this.username);
          if(!result) return;
          if(!result.data.categories) {
            this.categories = [];
            // 신규/빈 계정: 전체 카탈로그 카테고리를 filteredCategories에 세팅해야
            // openCategoryModal이 즉시 동작함
            this.modalData.filteredCategories = Array.from(
              new Set((this.modalData.wholeMenuData || []).map(i => i.category))
            ).sort((a, b) => String(a).localeCompare(String(b)));
            return;
          }
          this.uiHandler.applyPrivilegeCategories(deepCopy(result.data.categories));
        },
        /*

        /privileges raw categories를 UI 데이터 구조로 변환하여 this.categories와
        filteredCategories에 반영하는 공유 메서드.
        getPrivilegeInfo와 copyMenusFrom 양쪽에서 호출.

        rawCategories: deepCopy된 배열 (원본 변이 없음)

        */
        // @MX:ANCHOR: [AUTO] getPrivilegeInfo·copyMenusFrom 양쪽에서 호출되는 권한 변환 단일 진입점
        // @MX:REASON: [AUTO] 변환 로직 중복 방지 — fan_in 2 (내부 패턴상 단일 책임 보장)
        applyPrivilegeCategories: (rawCategories) => {
          rawCategories.forEach(item => {
            item.menu.forEach(menu => {
              menu.isNewWindow = convertYnToBool(menu.isNewWindow);
              if(!menu.readOptions) {
                menu.read = convertYnToBool(menu.read);
              } else {
                menu.read = 'M';
                const selectedItem = menu.readOptions.find(option => option.value === enums().YnEnum.Y);
                menu.selectedOption = selectedItem;
              }
              menu.write = convertYnToBool(menu.write);
              menu.update = convertYnToBool(menu.update);
              menu.delete = convertYnToBool(menu.delete);
              menu.excel = convertYnToBool(menu.excel);
            });

            const categoryName = item.name;
            const array = deepCopy(this.modalData.wholeMenuData.filter(menuItem => menuItem.category === categoryName));
            const targetMenuNames = deepCopy(item.menu).map(menuItem => menuItem.menuName);
            const filteredArray = array.filter(menuItem => !targetMenuNames.includes(menuItem.name));

            item.shouldShowAddMenuBtn = filteredArray.length > 0;
          });

          this.categories = rawCategories;

          const allCats = Array.from(new Set(this.modalData.wholeMenuData.map(item => item.category)));
          // P2-⑥(a): 피커 정렬 — locale-aware 사전순
          this.modalData.filteredCategories = allCats
            .filter(uniqueCategory => !this.categories.some(category => category.name === uniqueCategory))
            .sort((a, b) => String(a).localeCompare(String(b)));
        },
        /*

        메뉴 복사: sourceUsername의 권한을 가져와 현재 편집 세션에 반영.
        실제 저장은 하지 않음 — 사용자가 "권한 저장"을 눌러야 반영됨.

        */
        copyMenusFrom: async (sourceUsername) => {
          // 소스 미선택
          if (!sourceUsername || !sourceUsername.trim()) {
            await oneBtnDialog(
              this.$t('menuModal_copy_no_source_title'),
              this.$t('menuModal_copy_no_source_msg'),
              false
            );
            return;
          }
          // 자기 자신 복사 방지
          if (sourceUsername.trim() === this.username) {
            await oneBtnDialog(
              this.$t('menuModal_copy_self_title'),
              this.$t('menuModal_copy_self_msg'),
              false
            );
            return;
          }
          // 기존 메뉴가 있으면 덮어쓰기 확인
          if (this.categories && this.categories.length > 0) {
            const confirmed = await twoBtnDialog(
              this.$t('menuModal_copy_overwrite_title'),
              this.$t('menuModal_copy_overwrite_msg'),
              this.$t('menuModal_copy_confirm_btn'),
              this.$t('common_cancel')
            );
            if (!confirmed) return;
          }
          const result = await this.apiHandler.getPrivilegeInfo(sourceUsername.trim());
          if (!result || !result.data || !result.data.categories || result.data.categories.length === 0) {
            await oneBtnDialog(
              this.$t('menuModal_copy_empty_title'),
              this.$t('menuModal_copy_empty_msg'),
              false
            );
            return;
          }
          // deepCopy로 소스 원본 변이 방지
          this.uiHandler.applyPrivilegeCategories(deepCopy(result.data.categories));
          // 복사 패널 닫기 및 선택 초기화
          this.copyPanel.open = false;
          this.copyPanel.selectedUsername = undefined;
          this.copyPanel.typedUsername = '';
          await oneBtnDialog(
            this.$t('menuModal_copy_success_title'),
            this.$t('menuModal_copy_success_msg'),
            false
          );
        },
        /*

        /privileges로 가져온 데이터의 menu 항목을 /menu/list의 menu 항목 데이터셋에 맞도록 변경

        */
        computeMenuObject: (rawObj) => {
          const obj = {};
          obj.menuId = rawObj._id;
          obj.category = rawObj.category;
          obj.menuName = rawObj.name;
          obj.link = rawObj.link;
          obj.iconDefaultUrl = rawObj.iconDefaultUrl;
          obj.iconActiveUrl = rawObj.iconActiveUrl;
          obj.isNewWindow = rawObj.isNewWindow === YnEnum.Y ? true : false;
          if(rawObj.readOptions) {
            obj.read = 'M';
            obj.readOptions = rawObj.readOptions;
            obj.selectedOption = rawObj.readOptions.find(item => item.value === YnEnum.Y);
          } else {
            obj.read = true;
          }
       
          obj.write = true;
          obj.update = true;
          obj.delete = true;
          obj.excel = true;
          return obj;
        },
        /*

        권한 수정 전 validation

        */
        validateData: async () => {
          const lengthCheck = this.categories.some(item => item.menu.length === 0);
          if(this.categories.length === 0) {
            await oneBtnDialog(this.$t('menuModal_category_empty_title'), this.$t('menuModal_category_empty_validate_msg'), false);
            return false;
          }
          if(lengthCheck) {
            await oneBtnDialog(this.$t('menuModal_menu_empty_title'), this.$t('menuModal_menu_empty_validate_msg'), false);
            return false;
          }

          return true;
        },
        /*

        권한 정보 수정

        boolean에서 다시 Yn값으로 변경 후 categories 안에 담아 보냄

        readOptions가 있는 경우에(전자계약)는
        read의 값을 M으로 변경
        selectedOption의 키값을 Y로, 나머지는 N으로 변경
        이후 seelctedOption 값 자체를 제거

        */
        updatePrivilegeInfo: async () => {
          if(!await this.uiHandler.validateData()) return;
          
          const newArray = this.categories.map(category => ({
            ...category,
            menu: category.menu.map(menu => {
              const modifiedReadOptions = menu.readOptions && menu.selectedOption ? menu.readOptions.map(option => ({
                ...option,
                value: option.key === menu.selectedOption.key ? YnEnum.Y : YnEnum.N
              })) : menu.readOptions;

              const { selectedOption, ...newMenuWithoutSelectedOption } = menu;

              return {
                ...newMenuWithoutSelectedOption,
                isNewWindow: boolToYn(menu.isNewWindow),
                read: menu.readOptions ? 'M' : boolToYn(menu.read),
                write: boolToYn(menu.write),
                update: boolToYn(menu.update),
                delete: boolToYn(menu.delete),
                excel: boolToYn(menu.excel),
                ...(modifiedReadOptions && { readOptions: modifiedReadOptions })
              };
            })
          }));

          const obj = {};
          obj.username = this.username;
          obj.categories = newArray;
          // SPEC-CHINA-PRIV-AUDIT-001: 변경 사유(선택) 전달 — 감사 이력에 기록
          const reasonTrimmed = (this.changeReason || '').trim();
          if (reasonTrimmed) obj.reason = reasonTrimmed;
          const result = await this.apiHandler.updatePrivilegeInfo(obj);
          if(result.status !== 200 && result.status !== 201) return;
          // 저장 성공 시 사유 입력/이력 캐시 초기화(다음 오픈 시 새 이력 로드)
          this.changeReason = '';
          this.auditPanel.loaded = false;
          this.auditPanel.items = [];
          // P2-②: 자기 자신 권한 편집 시 사이드바 즉시 갱신 (store 캐시 force refresh)
          if (this.username === jwtUsername()) {
            try {
              await this.$store.dispatch('getPrivileges', { username: this.username, force: true });
            } catch (e) {
              console.log(e); // 갱신 실패해도 저장은 완료 — 다음 로그인 시 반영
            }
          }
          // P2-②: 반영 시점 안내 — 대상이 로그인 중이면 다음 로그인(또는 강제 로그아웃) 후 반영
          await oneBtnDialog(this.$t('menuModal_privilege_update_success_title'), this.$t('menuModal_privilege_update_success_msg'), false);
          this.uiHandler.closeModal();
        }
      }
    },
    api() {
      return {
        // @MX:NOTE: [AUTO] SPEC-CHINA-MENU-CATALOG-001 — 메뉴 마스터를 한국 inapi POST /menus/list에서
        //   china-inapi GET /menus/catalog로 전환. 사이드바 hydration(GET /privileges)과 동일한
        //   xinlaian menus + 동일 locale 값이므로 category/name 문자열 조인이 항상 일치.
        getMenuList: async () => {
          try {
            // 편집 대상 계정의 role로 카탈로그를 요청한다 — 운영자(XINLAIAN) 계정을 편집할 땐
            // 운영자 메뉴가, 제조사 계정을 편집할 땐 제조사 메뉴가 피커에 뜬다.
            // targetRole 미지정 시 store가 기존 기본값(MANUFACTURER)으로 폴백한다.
            const response = await this.$store.dispatch('fetchMenuCatalog', this.targetRole);
            if (response.status !== 200 && response.status !== 201) return;
            return response;

          } catch (error) {
            console.log(error);
            // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDEBAR-CONSOLID-001 — i18n key로 다국어 처리
            await oneBtnDialog(this.$t('menu_load_error_title'), this.$t('menu_load_error_content'), false);
          }
        },
        // @MX:NOTE: [AUTO] SPEC-CHINA-PRIV-AUDIT-001 — 감사 이력 조회. 실패는 호출부(loadAudits)에서 처리하도록 rethrow.
        getPrivilegeAudits: async (username, limit) => {
          return await this.$store.dispatch('fetchPrivilegeAudits', { username, limit });
        },
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-STORE-HYGIENE-001 — store action 단일 진입점 (fetchPrivilegesRaw)
        //   사이드바(getPrivileges)와 분리한 raw action. 빈 메뉴 카테 포함 원본 응답이 필요.
        getPrivilegeInfo: async (username) => {
          try {
            const response = await this.$store.dispatch('fetchPrivilegesRaw', username);
            if (response.status !== 200 && response.status !== 201) return;
            return response;

          } catch (error) {
            console.log(error);
            // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDEBAR-CONSOLID-001 — i18n key로 다국어 처리
            await oneBtnDialog(this.$t('menu_load_error_title'), this.$t('menu_load_error_content'), false);
          }
        },
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-STORE-HYGIENE-001 — store action 단일 진입점 (updatePrivilege)
        //   기존: chinaInapi.post (SPEC-CHINA-INAPI-PRIV-CREATE-003 B1)
        //   현재: dispatch('updatePrivilege') 위임 — fetch 책임 store 일원화
        updatePrivilegeInfo: async (obj) => {
          try {
            const response = await this.$store.dispatch('updatePrivilege', obj);
            if (response.status !== 200 && response.status !== 201) return;
            return response;

          } catch (error) {
            console.log(error);
            await oneBtnDialog(this.$t('menuModal_privilege_update_fail_title'), this.$t('menuModal_privilege_update_fail_msg'), false);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/menu-manage.scss';

/* 메뉴 경로 병기 — 카드·추가 서브모달 공용. 이름 옆 보조 신원이라 작고 옅게 */
.menu-link-sub {
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 11px;
  color: #8b95a1;
  margin-left: 6px;
  word-break: break-all;
}

/* 메뉴 피커 전용 1열 배치 — 이름+경로 병기가 grid auto-fit 다열에서 겹치는 것 방지.
   카테고리 피커는 기존 다열 유지(이 클래스 미부여) */
.menu-checkboxes--menu-picker {
  grid-template-columns: 1fr;
  label {
    white-space: normal;
  }
}



@media screen and (max-width:767px) {
  .row{
    padding: 14px 14px 36px 14px !important
  }
  .item-btn-area{
    max-width: none;
  }
  p{
    margin-bottom: 0;
  }
}
@media screen and (min-width:768px) and (max-width:1023px){
  .w-35 {
    width: 50% !important;
  }
  p{
    margin-bottom: 0;
  }
}
</style>